import Select from "react-select";

const SelectComponent = ({ title, placeholder, ...rest }) => {
  return (
    <div className="flex flex-col gap-2 items-start w-[48%] md:w-36 mb-4">
      <span className="text-xs">{title}</span>
      <Select
        isSearchable={false}
        className="text-xs w-full"
        {...rest}
        placeholder={<div>{placeholder}</div>}
      />
    </div>
  );
};

export default SelectComponent;
